export const addGMTOffsetToDate = (dateString: string = null) => {
  if (!dateString) {
    return "";
  }
  const date = new Date(dateString);
  const timezoneOffset = date.getTimezoneOffset();
  const gmtOffsetInHours = timezoneOffset / 60;
  date.setHours(23 - gmtOffsetInHours, 59, 0, 0);

  return date;
};
